import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';

const Subscriptions = React.lazy(() => import('./index'));
const SubscriptionTable = React.lazy(() => import('./subscriptionTable'));
const Subscription = React.lazy(() => import('./subscription'));
const SubscriptionDetail = React.lazy(() => import('./subscriptionDetail'));


export const useSubscriptionRoutes = () => {
    return (
        <Route path="subscriptions" element={<Suspense fallback={<div>منتظر باشید...</div>}><Subscriptions /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><SubscriptionTable/></Suspense> } />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><div>این قسمت هنوز آماده نیست!</div></Suspense>} />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><Subscription /></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><SubscriptionDetail/></Suspense> } />
            </Route>
        </Route>
    )
}

